import { _types } from './_types';
import { generateState } from './utils';

export const mutations = {
  [_types.SET_CURRENT_MODE](state, { mode }) {
    state.mode = mode;
  },

  [_types.SET_CURRENT_STATUS](state, { status }) {
    state.currentStatus = status;
  },

  [_types.SET_CURRENT_STATUS_TARGET](state, { statusTarget }) {
    state.currentStatusTarget = statusTarget;
  },

  [_types.SET_TABS_STATE](state, { config, userRole }) {
    state.tabsState = generateState({
      config,
      status: state.currentStatus,
      statusTarget: state.currentStatusTarget,
      requestTypeId: state.requestTypeId,
      userRole,
    });
  },

  [_types.SET_STATUS_TARGETS](state, { statusTargets }) {
    state.statusTargets = statusTargets;
  },

  [_types.SET_CURRENT_TAB](state, { tab }) {
    if (tab !== undefined || tab !== null) {
      state.currentTab = tab;
    }
  },

  [_types.SET_APPROVAL_NOTIFIED_INFO](state, info) {
    if (info) {
      const { academicYear, determination } = info;
      state.approvalInfo = { academicYear, determination };
    } else {
      state.approvalInfo = { academicYear: null, determination: null };
    }
  },

  [_types.SET_CURRENT_REQUEST_TYPE_ID](state, requestTypeId) {
    state.requestTypeId = requestTypeId;
  },
};
